import { baseApiV2 } from '@verantos-dev/app-state-base';
import { ListResponse, ObjectResponse } from '@verantos-dev/types-common';

import { DATASET_DELIVERY_BASE_PATH, DATASET_DELIVERY_TAG } from './constants';
import type {
  DatasetDeliveryTableDetails,
  PatchDatasetDeliveryRequest,
  DatasetManifestTableDetails,
} from './types';

// inject endpoints for feature into the baseApi
const datasetDeliveryApiSlice = baseApiV2
  .enhanceEndpoints({
    addTagTypes: [DATASET_DELIVERY_TAG],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllDatasetDelivery: builder.query<
        ListResponse<DatasetDeliveryTableDetails>,
        string | null | undefined
      >({
        query: (urlParams: string) => {
          const params = urlParams ? `${encodeURI(urlParams)}` : '';
          return `/${DATASET_DELIVERY_BASE_PATH}/${params}`;
        },
        providesTags: [DATASET_DELIVERY_TAG],
      }),
      getDatasetDeliveryDetail: builder.query<
        ListResponse<DatasetManifestTableDetails>,
        string | null | undefined
      >({
        query: (dataset: string) => {
          return `/${DATASET_DELIVERY_BASE_PATH}/${dataset}/manifest`;
        },
        providesTags: [DATASET_DELIVERY_TAG],
      }),
      patchDatasetDelivery: builder.mutation<
        ObjectResponse<DatasetDeliveryTableDetails>,
        PatchDatasetDeliveryRequest
      >({
        query: ({ dataset, data }) => ({
          url: `/${DATASET_DELIVERY_BASE_PATH}/${dataset}`,
          method: 'PATCH',
          body: data,
        }),
        invalidatesTags: [DATASET_DELIVERY_TAG],
      }),
    }),
  });

// export hooks to access/fetch data
export const {
  useGetAllDatasetDeliveryQuery,
  usePatchDatasetDeliveryMutation,
  useGetDatasetDeliveryDetailQuery,
} = datasetDeliveryApiSlice;
